/**
 * Sonneries générées avec Web Audio (aucun fichier à charger).
 * - incoming : double bip répété (appel entrant)
 * - outgoing : tonalité de retour d'appel, longue et douce (appel sortant en attente)
 * Retourne une fonction stop().
 */
export function playRingtone(type = 'incoming') {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return () => {};
  let ctx;
  try {
    ctx = new AudioCtx();
  } catch {
    return () => {};
  }

  const beep = (start, duration, freq, volume) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(volume, start + 0.02);
    gain.gain.setValueAtTime(volume, start + duration - 0.05);
    gain.gain.linearRampToValueAtTime(0, start + duration);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + duration);
  };

  const cycle = () => {
    const t = ctx.currentTime + 0.05;
    if (type === 'incoming') {
      beep(t, 0.35, 880, 0.18);
      beep(t + 0.45, 0.35, 880, 0.18);
    } else {
      beep(t, 1.2, 440, 0.06);
    }
  };

  cycle();
  const timer = setInterval(cycle, type === 'incoming' ? 2000 : 4000);
  return () => {
    clearInterval(timer);
    ctx.close().catch(() => {});
  };
}
